export default __webpack_public_path__ + "static/media/FTDs.5f1e9892.svg";